import LockIcon from "@mui/icons-material/Lock";
import { Chip, Fab, Stack } from "@mui/material";
import { blue, green, grey, orange } from "@mui/material/colors";
import * as React from "react";
import { GUTIL_EXP, VERSION_LIST, VER_TAG } from "../../firebase/creds/setup";
import { GitHub } from "@mui/icons-material";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import { PROJECT_LINK } from "../../appconfig/info";

const OutButton = React.memo(function OutButton({ handleLogout }) {
	const [msg, setMsg] = React.useState();
	function copyToClipboard() {
		navigator.clipboard.writeText(this.copyString);
		setMsg("coppied!");

		setTimeout(() => {
			setMsg("");
		}, 4000);
	}

	const baseURL = `${
		window.location.protocol + "//" + window.location.host
	}/`;

	return (
		<>
			<Stack justifyContent="center">
				<Stack
					sx={{ m: 2, mr: 0, flexWrap: "wrap" }}
					flexDirection="row"
				>
					<Chip
						icon={<GitHub />}
						sx={{ m: ["auto", 2, 1] }}
						label="github"
						component="a"
						target="_blank"
						href={PROJECT_LINK}
						variant="outlined"
					/>
					<Chip
						sx={{ m: ["auto", 1], color: blue[400] }}
						label="eko dashboard"
						component="a"
						target="_blank"
						href="https://app.ekodevices.com/"
						variant="outlined"
					/>
					<Chip
						icon={<WhatshotIcon fontSize="small" />}
						sx={{ m: ["auto", 2, 1], color: orange[600] }}
						label="firebase"
						component="a"
						target="_blank"
						href="https://console.firebase.google.com/u/0/project/pnoistor/storage/pnoistor.appspot.com/files"
						variant="outlined"
					/>
					<Chip
						sx={{ m: ["auto", 2, 1], color: grey[200] }}
						label={msg ? msg : "gutil export"}
						onClick={copyToClipboard.bind({
							copyString: GUTIL_EXP,
						})}
						variant="outlined"
					/>

					{VERSION_LIST.map((ver) => {
						return (
							<Chip
								sx={{ m: ["auto", 2, 1], color: green[200] }}
								label={`ver: ${ver}`}
								component="a"
								target="_blank"
								href={`${baseURL}?${VER_TAG}=${ver}`}
								variant="outlined"
							/>
						);
					})}
				</Stack>
				<Fab
					aria-label="logout"
					variant="extended"
					onClick={handleLogout}
				>
					<LockIcon sx={{ mr: 1 }} />
					Logout
				</Fab>
			</Stack>
		</>
	);
});

export default OutButton;
